import { render, staticRenderFns } from "./dg-website-brands-banner.vue?vue&type=template&id=e2c36b76&scoped=true&"
import script from "./dg-website-brands-banner.vue?vue&type=script&lang=js&"
export * from "./dg-website-brands-banner.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=e2c36b76&scoped=true&lang=css&"
import style1 from "./dg-website-brands-banner.vue?vue&type=style&index=1&id=e2c36b76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c36b76",
  null
  
)

export default component.exports